import { noop } from "es-toolkit";
import type { AttachReset } from "../forms/controller";
import type { MikrotikParam } from "./types.common";

export const defaultEmptyRadiusProfile = {
    isActive: false,
    mikrotikProfile: undefined,
    uploadSpeed: undefined,
    downloadSpeed: undefined,
    useBurst: false,
    uploadBurstLimit: undefined,
    downloadBurstLimit: undefined,
    uploadBurstThreshold: undefined,
    downloadBurstThreshold: undefined,
    uploadBurstTime: undefined,
    downloadBurstTime: undefined,
    priority: undefined,
    uploadLimitAt: undefined,
    downloadLimitAt: undefined,
} satisfies MikrotikParam;

export const defaultResetFn: () => AttachReset<undefined> = () => ({
    resetVal: undefined,
    detachFn: noop,
});
